import styles from './Toast.module.css';

export const Toast = ({ message, variant, onDismiss, dismissLabel }) => {
  const variantClass = variant && styles[variant] ? styles[variant] : '';

  return (
    <div className={`${styles.toast} ${variantClass}`} role="status">
      <span className={styles.message}>{message}</span>
      <button
        type="button"
        className={styles.dismiss}
        onClick={onDismiss}
        aria-label={dismissLabel}
      >
        ×
      </button>
    </div>
  );
};
